'use strict';
module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ./~/shortid/index.js
// module id = 2276
// module chunks = 0